import type { KeyboardEvent } from 'react';

/** Arrow, Home and End keys move focus between the enabled options of a filter list. */
export function navigateOptions(event: KeyboardEvent<HTMLButtonElement>): void {
  const rows = Array.from(event.currentTarget.parentElement?.querySelectorAll<HTMLButtonElement>('button:not(:disabled)') ?? []);
  const index = rows.indexOf(event.currentTarget);
  const next = event.key === 'ArrowDown' ? (index + 1) % rows.length : event.key === 'ArrowUp' ? (index - 1 + rows.length) % rows.length : event.key === 'Home' ? 0 : event.key === 'End' ? rows.length - 1 : null;
  if (next === null) return;
  event.preventDefault();
  rows[next]?.focus();
}
